import type { PresentationData } from "../PresentationsNavigator/types";
import { PresentationsList } from "./PresentationsList";
import { PresentationView } from "./PresentationView";

type PresentationsNavigatorProps = {
    presentations: PresentationData[];
    presentation: PresentationData | null;
    setPresentation: (data: PresentationData | null) => void;
};

export const PresentationsNavigator = ({
    presentations,
    presentation,
    setPresentation,
}: PresentationsNavigatorProps) => {
    return presentation ? (
        <PresentationView presentation={presentation} />
    ) : (
        <PresentationsList presentations={presentations} setCurrentPresentation={setPresentation} />
    );
};
